import { FC } from 'react'
import Link from 'next/link'
import NextImage from '../../UI/nextImage/NextImage';
import styles from './Logo.module.scss'
import logo from '@/public/Logo.svg'

type TLogo = {
  sizes: string
  className?: string
}

const Logo: FC<TLogo> = ({sizes, className}) => {

  return (
    <Link 
        href='/' 
        className={`${styles.logo} ${className ?? null}`}> 
            <NextImage 
                alt='Offers Bet'
                src={logo}
                fill
                sizes={sizes}
                priority
            />
    </Link>
  )
}

export default Logo